import _slicedToArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { useEffect, useState } from 'react';
import LocalStorage from '../helpers/LocalStorage';
import { useConfig } from './useConfig';
function getItem(key, storage) {
  var item = storage.getItem(key);
  if (item !== null) {
    try {
      return JSON.parse(item);
    } catch (_a) {
      // ignore error
    }
  }
}
function setItem(key, value, storage) {
  if (value === undefined) {
    storage.removeItem(key);
  } else {
    var toStore = JSON.stringify(value);
    try {
      storage.setItem(key, toStore);
      return JSON.parse(toStore);
    } catch (err) {
      console.error('Error in localStorage', err);
      storage.removeItem(key);
    }
  }
}
/**
 * @internal Intended for internal use - use it on your own risk
 */
export function useLocalStorage(key) {
  var _useConfig = useConfig(),
    _useConfig$localStora = _useConfig.localStorageOverride,
    localStorageOverride = _useConfig$localStora === void 0 ? typeof window !== 'undefined' && typeof window.localStorage !== 'undefined' && typeof window.localStorage.setItem === 'function' ? window.localStorage : new LocalStorage() : _useConfig$localStora;
  var _useState = useState(function () {
      return getItem(key, localStorageOverride);
    }),
    _useState2 = _slicedToArray(_useState, 2),
    value = _useState2[0],
    setValue = _useState2[1];
  useEffect(function () {
    setValue(getItem(key, localStorageOverride));
  }, [key]);
  useEffect(function () {
    setItem(key, value, localStorageOverride);
  }, [value]);
  // As value updating relies on useEffect, it takes multiple rerenders to fully update the value.
  // The third element in the return array allows to get the immediate value stored in the localStorage.
  return [value, setValue, function () {
    return getItem(key, localStorageOverride);
  }];
}